export default __webpack_public_path__ + "static/media/colabSVG.f642dfcf.svg";